import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from "rxjs";
import {QueryResult} from "@app/shared";


@Injectable()
export class ModHistoryService {

  constructor (private http: HttpClient) { }

  getModHistory(componentType: string, componentId: number, type: string): Observable<QueryResult> {
    const url = `/${componentType}/mod-histories?id=${componentId}&type=${type}`;
    return this.http.get<QueryResult>(url);
  }
}
